module.exports = __webpack_public_path__ + "img/map.ad95a9b9.png";